// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { N50, N70 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { borderRadius } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledClearButton = styled.div({
	background: 0,
	border: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${borderRadius() / 2}px`,
	color: token('color.text.subtlest', N50),
	cursor: 'pointer',
	height: token('space.300', '24px'),
	lineHeight: 1,
	outline: 0,
	padding: 0,
	display: 'flex',
	alignItems: 'center',
	marginLeft: token('space.025', '2px'),
	transition: 'background-color 200ms opacity 200ms',
	width: token('space.300', '24px'),
	'&:hover, &:focus': {
		color: token('color.text.subtle', N70),
	},
});
